export default __webpack_public_path__ + "static/media/cupon-Gatchina.3120eddc.pdf";